function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "rhytgram");

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  x1: 55.72,
  y1: 494.03,
  x2: 55.72,
  y2: 277.05,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  x1: 106.94,
  y1: 494.03,
  x2: 106.94,
  y2: 392.17,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  x1: 169.61,
  y1: 494.03,
  x2: 169.61,
  y2: 277.05,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref6 =
/*#__PURE__*/
React.createElement("line", {
  x1: 339.01,
  y1: 318.17,
  x2: 339.01,
  y2: 2.82,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref7 =
/*#__PURE__*/
React.createElement("line", {
  x1: 422.59,
  y1: 494.03,
  x2: 422.59,
  y2: 69.1,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref8 =
/*#__PURE__*/
React.createElement("line", {
  x1: 106.94,
  y1: 359.83,
  x2: 106.94,
  y2: 133.2,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref9 =
/*#__PURE__*/
React.createElement("line", {
  x1: 184.3,
  y1: 228.83,
  x2: 184.3,
  y2: 1.59,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref10 =
/*#__PURE__*/
React.createElement("line", {
  x1: 55.72,
  y1: 246.82,
  x2: 55.72,
  y2: 19.58,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref11 =
/*#__PURE__*/
React.createElement("line", {
  x1: 299.49,
  y1: 381.32,
  x2: 299.49,
  y2: 172.77,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-40.36,223.4",
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M815.74,17.58",
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-33.52,385.54",
  fill: "#fff",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref15 =
/*#__PURE__*/
React.createElement("line", {
  x1: 239.15,
  y1: 494.1,
  x2: 239.15,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 30
});

var _ref16 =
/*#__PURE__*/
React.createElement("line", {
  x1: 378.53,
  y1: 494.64,
  x2: 378.53,
  y2: 268.01,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var _ref17 =
/*#__PURE__*/
React.createElement("line", {
  x1: 4.5,
  y1: 349.27,
  x2: 4.5,
  y2: 122.64,
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  strokeWidth: 9
});

var SvgRhytgram = function SvgRhytgram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "b90d23df-2b2c-4a4d-b56e-c068f52fb0a8",
    "data-name": "af885224-48a3-4ec7-8a2d-a114958f43e4",
    viewBox: "0 0 427.09 494.64",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRhytgram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rhytgram.45d0f1d2.svg";
export { ForwardRef as ReactComponent };